var loadURL = function(url) {
  var iFrame;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url);
  iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px");
  iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0");
  document.body.appendChild(iFrame);
  // 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}

export function openService(openSource, openType, functioncode, parameters) {
  var ua = window.navigator.userAgent.toLowerCase();
  //判断当前设备是否为苹果
  if (ua.match(/iphone|ipod|ipad/)) {
    // 1.JSON数据转成字符串
    var JSONString = JSON.stringify(parameters);
    // 2.将JSON字符串中的":"转换成"%3A"
    JSONString = JSONString.split(":").join("%3A");
    // 3.拼接请求
    var requestString = "KDS_Native://openService:" + openSource + ":" + openType + ":" + functioncode + ":" +
      JSONString;
    // 4.发送请求
    loadURL(requestString);
    //判断当前设备是否为安卓
  } else if (ua.match(/android/i)) {
    //console.log('andorid');
    window.KDS_Native.openService(openSource, openType, functioncode, JSON.stringify(parameters));
  } else {
    //console.log('other');
  }
}

//活动倒计时 天/时/分/秒
export function changeTime(now,end){
  var end = end;
  var now = now;
  var msec = end - now;//时间差的毫秒数
  var str = {};
  if(msec > 0){
    var day = Math.floor(msec / (24 * 3600 * 1000));
    var hours = Math.floor(msec / (3600 * 1000)% 24);
    var minutes = Math.floor(msec / (60 * 1000)% 60);
    var seconds = Math.floor(msec / (1000)% 60);
    if(day < 10){
        day = '0' + day.toString();
    }
    if(hours < 10){
        hours = '0' + hours.toString();
    }
    if(minutes < 10){
        minutes = '0' + minutes.toString();
    }
    if(seconds < 10){
        seconds = '0' + seconds.toString();
    }
    str['day'] = day;
    str['hours'] = hours;
    str['minutes'] = minutes;
    str['seconds'] = seconds;
  }else{
    str = 0;
  }
  return str;
}
